export default __webpack_public_path__ + "static/media/logo-short-inverted.c6edc2ec.svg";